import { createQueryKeys } from "@lukemorales/query-key-factory";
import type { WorkPacketType } from "src/pages/UserDashboard/WorkPackets/WorkPacketType";
import type { WorkPacketFilters } from "src/types/work-packets";
import { getDisputesIdsAndVendorInfo } from "src/pages/UserDashboard/Cases/api/casesApi";

export const workPackets = createQueryKeys("work-packets", {
  preCaseData: (params: {
    workPacketType: WorkPacketType;
    workPacketIds: string[];
    excludedWorkPackets: string[];
    filters: WorkPacketFilters;
  }) => ({
    queryKey: [params],
    queryFn: ({ signal }) => getDisputesIdsAndVendorInfo(params, signal),
  }),
});
